export default __webpack_public_path__ + "static/media/p1 a.578572ba.svg";